<script>
import { formatTimestamp } from '../utils/formatTimestamp'
import { api } from '../../../firebase'

export default {
  name: 'MobilizeV2CampaignDetail',
  async mounted() {
    await this.load()
  },
  data() {
    return {
      loadingState: {
        pending: false,
        done: false,
        error: null
      },
      campaign: null,
      // eslint-disable-next-line
      dummyData: {
        result: {
          id: 1,
          data: {
            name: 'Campaign',
            events: [123123, 1231231],
            textTemplates: [123123, 533452],
            imageTemplates: [123123324, 345453],
            campaignId: 12312,
            adSets: [
              { id: 1, name: 'Another', event: 12312312 },
              { id: 2, name: 'Another 2', event: 129098782 }
            ],
            ads: [
              {
                id: 2,
                name: 'An Ad',
                event: 1231231,
                textTemplate: 1123123,
                imageTemplate: 123123123,
                renderedText: {
                  headline: 'Headline',
                  body: 'body body',
                  linkDescription: 'something',
                  renderedImage: 'something.png'
                }
              },
              {
                id: 2,
                name: 'An Ad',
                event: 1231231,
                textTemplate: 1123123,
                imageTemplate: 123123123,
                renderedText: { headline: 'Headline', body: 'body body', linkDescription: 'something' }
              },
              {
                id: 2,
                name: 'An Ad',
                event: 1231231,
                textTemplate: 1123123,
                imageTemplate: 123123123,
                renderedText: { headline: 'Headline', body: 'body body', linkDescription: 'something' }
              }
            ]
          }
        }
      },
      testing: false
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    createdDateTime() {
      return this.campaign ? formatTimestamp(this.campaign.createTime) : null
    },
    lastModifiedDateTime() {
      return this.campaign ? formatTimestamp(this.campaign.updateTime) : null
    },
    formatTimestamp() {
      return formatTimestamp
    }
  },
  methods: {
    async load() {
      this.loadingState = {
        pending: true,
        done: false,
        error: null
      }
      try {
        const id = this.id
        const { result } = this.testing ? this.dummyData : await api.campaigns.findById({ id })
        const ads = await api.ads.find({ filters: [{ key: 'campaign', comparator: '==', value: id }] })
        const adSets = await api.adSets.find({ filters: [{ key: 'campaign', comparator: '==', value: id }] })
        this.campaign = result
        this.ads = ads.results
        this.adSets = adSets.results
        this.loadingState.done = true
      } catch (error) {
        this.loadingState.error = error
      } finally {
        this.loadingState.pending = false
      }
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view detail">
    <h1>Campaign Details</h1>

    <h2>Summary</h2>

    <div v-if="loadingState.pending">
      <v-alert>Loading...</v-alert>
    </div>
    <div v-else-if="loadingState.error">
      <v-alert outlined color="red">
        <p>An error occurred while loading the campaign.</p>
        <p>{{ loadingState.error.message }}</p>
      </v-alert>
    </div>
    <div v-else-if="loadingState.done">
      <v-simple-table class="campaign-details-table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>ID</td>
              <td>{{ campaign.id }}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>{{ campaign.data.name }}</td>
            </tr>
            <tr>
              <td>Events</td>
              <td>
                <ul>
                  <li :key="index" v-for="(id, index) in campaign.data.events">
                    <router-link :to="'/mobilizev2/events/' + id">{{ id }}</router-link>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Text templates</td>
              <td>
                <ul>
                  <li :key="index" v-for="(id, index) in campaign.data.textTemplates">
                    <router-link :to="'/mobilizev2/text-templates/' + id">{{ id }}</router-link>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Image templates</td>
              <td>
                <ul>
                  <li :key="index" v-for="(id, index) in campaign.data.imageTemplates">
                    <router-link :to="'/mobilizev2/image-templates/' + id">{{ id }}</router-link>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Campaign ID</td>
              <td>{{ campaign.data.campaignId }}</td>
            </tr>
            <tr>
              <td>Created</td>
              <td>{{ createdDateTime }}</td>
            </tr>
            <tr>
              <td>Last modified</td>
              <td>{{ lastModifiedDateTime }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="campaign-detail-ad-sets">
        <h2 v-if="adSets">Ad Sets</h2>
        <ul class="ad-sets">
          <li class="ad-sets-list-item" :key="index" v-for="(adSet, index) in adSets">
            <h3 class="my-4" v-if="adSets.length > 1">Ad Set {{ index + 1 }}</h3>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{{ adSet.data.id }}</td>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td>{{ adSet.data.name }}</td>
                  </tr>
                  <tr>
                    <td>Event</td>
                    <td>
                      <router-link :to="'/mobilizev2/events/' + adSet.event">{{ adSet.data.event }}</router-link>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </li>
        </ul>
      </div>
      <div>
        <h2 v-if="ads">Ads</h2>
        <ul class="ads">
          <li class="ads-list-item" :key="index" v-for="(ad, index) in ads">
            <h3 class="my-4" v-if="ads.length > 1">Ad {{ index + 1 }}</h3>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{{ ad.data.id }}</td>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td>{{ ad.data.name }}</td>
                  </tr>
                  <tr>
                    <td>Event</td>
                    <td>
                      <router-link :to="'/mobilizev2/events/' + ad.event">{{ ad.data.event }}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <td>Text template</td>
                    <td>
                      <router-link :to="'/mobilizev2/text-templates/' + ad.data.textTemplate">{{
                        ad.data.textTemplate
                      }}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <td>Image template</td>
                    <td>
                      <router-link :to="'/mobilizev2/image-templates/' + ad.data.imageTemplate">{{
                        ad.data.imageTemplate
                      }}</router-link>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="ads-copy-wrapper">
              <h4 v-if="ad.data.renderedText">Copy</h4>
              <v-simple-table v-if="ad.data.renderedText">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Headline</td>
                      <td>{{ ad.data.renderedText.headline }}</td>
                    </tr>
                    <tr>
                      <td>Body</td>
                      <td>{{ ad.data.renderedText.body }}</td>
                    </tr>
                    <tr>
                      <td>Link description</td>
                      <td>{{ ad.data.renderedText.linkDescription }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div class="ads-image-wrapper">
              <h4>Image</h4>
              <img class="img-preview" :src="ad.renderedImage || require('@/assets/img/girl-clock.png')" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/utilities/initial-variables.scss';

.img-preview {
  height: 250px;
  display: block;
  max-width: 100%;
  max-height: unset;
}

h2 {
  margin: 20px 0;
}

td {
  ul {
    padding: 0;

    li {
      margin: 10px 0;
      display: block;
    }
  }
}

.campaign-details-table tr > td:first-child {
  width: 200px !important;
  vertical-align: text-top;
  padding-top: 14px;
}

.ads,
.ad-sets {
  padding: 0;
}

.ads-list-item,
.ad-sets-list-item {
  display: block;
  margin: 0;
  margin-bottom: 40px;
  background: $light-gray;
  padding: 20px;
  border-radius: 10px;

  .theme--light.v-data-table {
    background: $light-gray;
  }

  tr > td:first-child {
    width: 200px !important;
    vertical-align: text-top;
    padding-top: 14px;
  }

  h4 {
    margin: 30px 0 10px 0;
  }
}

.ads-image-wrapper {
  width: 25vw;
}
</style>
